<template>
    <div>
        <v-row no-gutters>
            <v-col v-if="evictionRecords.length === 0" cols="12">
                <v-alert border="top" outlined icon="mdi-home-export-outline">
                    No Eviction Records Found
                </v-alert>
            </v-col>
            <template v-for="(eviction, index) in mappedEvictions">
                <v-col lg="4" md="3" sm="6" :key="index">
                    <screen-eviction
                        :eviction="eviction"
                        mode="print"
                    ></screen-eviction>
                </v-col>
            </template>
        </v-row>
    </div>
</template>
<script>
import WithCrimeRecords from "@components/screen/mixins/WithCrimeRecords";

export default {
    name: "applicant-evictions",
    mixins: [WithCrimeRecords],
    components: {
        ScreenEviction: () =>
            import("@components/screen/components/Search/ScreenEviction"),
    },
    props: {
        evictions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {
        this.evictionRecords = this.evictions;
    },
    methods: {},
};
</script>

<style scoped>
</style>